import { z } from 'zod';

/** Медиа шага онбординга (картинка или видео) */
export type StepMedia =
  | { type: 'image'; src: string; alt?: string }
  | { type: 'video'; src: string };

/** Один шаг онбординга */
export interface OnboardingStep {
  id: string;
  title: string;
  description: string;
  media?: StepMedia;
}

/** Контент шага из JSON (без медиа) */
export interface StepContent {
  id: string;
  title: string;
  description: string;
}

/** UI-подписи виджета (вынесены в контент под будущую локализацию) */
export interface WidgetUiLabels {
  title: string;
  stepLabel: string; // шаблон вида "Step {current} of {total}"
  previous: string;
  next: string;
  done: string;
  close: string;
  loadingMedia: string; // подпись плейсхолдера, пока грузится медиа шага
}

/** Структура контента (готова к будущим steps.<lang>.json) */
export interface GetStartedContent {
  ui: WidgetUiLabels;
  steps: StepContent[];
}

/** Ключ localStorage для состояния виджета в Песочнице (отдельно от creativeHub) */
export const LOCAL_STORAGE_KEY = 'al-get-started-widget';

/** Схема состояния виджета, сохраняемого в localStorage */
export const GetStartedStateSchema = z.object({
  /** ID открытого шага. null — все закрыты */
  openStepId: z.string().nullable(),
  /** Список завершённых шагов (чекбоксы) */
  completedStepIds: z.array(z.string()),
  /** true — виджет полностью скрыт (закрыт/пропущен/пройден пользователем), не показывается автоматически */
  hidden: z.boolean(),
});

export type GetStartedState = z.infer<typeof GetStartedStateSchema>;
